export const DISCORD_URL = "https://discord.gg/wxBjaKfhDu";
